<template>
  <div class="md:hidden mb-8">
    <filter-single
      v-for="category in categories"
      :key="category.slug"
      :category="category"
    />
  </div>
</template>

<script>
import { computed } from 'vue'

import searchFactory from '@/compositions/search/SearchFactory'
import searchConfig from '@/compositions/search/SearchConfiguration'
import searchQueryState from '@/compositions/search/SearchQuery'

import FilterSingle from './SearchCategorySingleMobileProduct.vue'

export default {
  components: {
    FilterSingle
  },
  setup() {
    const { totalCount } = searchFactory.useSearchResult()
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const { activeCategories } = searchQueryState.searchQueryUse()

    return {
      activeCategoriesCount: computed(() => activeCategories.value.length),
      categories: computed(() => getActiveConfig().categories),
      translations: computed(() => getActiveConfig().translations),
      totalCountText: computed(() => getActiveConfig().translations.totalCountMobileMessage.replace('{0}', totalCount.value))
    }
  }
}
</script>
